import './Funds.css';
import farmsLogo from '../../assets/icons/subcompanies/FARMS.jpeg';
import mastercardLogo from '../../assets/icons/subcompanies/Mastercard-logo.svg.webp';
import agroLogo from '../../assets/icons/subcompanies/images.jpeg';

export default function Funds() {
    return (
        <div className="partners-section">
            <div className="partners-container">
                <h2 className="partners-title">Partners</h2>
                <div className="partners-row">
                    <div className="partner-logo">
                        <img src={farmsLogo} alt="Showbouy Farms" />
                    </div>
                    <div className="partner-logo">
                        <img src={agroLogo} alt="Agro Partnership" />
                    </div>
                    <div className="partner-logo">
                        <img src={mastercardLogo} alt="Mastercard" />
                    </div>
                    <div className="partner-logo placeholder-logo st-chartered">
                        <div className="p-icon">SC</div>
                        <div className="p-text">Standard<br/>Chartered</div>
                    </div>
                    <div className="partner-logo placeholder-logo giz">
                        <div className="p-icon">giz</div>
                    </div>
                    <div className="partner-logo placeholder-logo farmerline">
                        <div className="p-box">FARMERLINE</div>
                    </div>
                    <div className="partner-logo placeholder-logo canada">
                        <div className="p-icon"><i className="fas fa-leaf"></i></div>
                        <div className="p-text">Canada</div>
                    </div>
                </div>
            </div>
        </div>
    );
}